<template>
  <div style="position: relative;">
    <div class="overlay-news" v-if="openNews" @click="toggleMenuNews"></div>
    <div class="NewsPanel">
      <div :class="openNews ? 'bell-icon open' : 'bell-icon'" @click="toggleMenuNews">
        <BellIcon :class="unreadNews.length > 0 ? 'animated' : ''" ref="bellIcon"/>
        <span class="quantity-news" v-if="unreadNews.length > 0">{{ quantity }}</span>
      </div>
      <div class="news-menu" v-if="openNews" v-click-outside="closeMenu">
        <div class="news-menu-header">
          Notificaciones
        </div>
        <div class="news-menu-body" v-if="unreadNews.length > 0">
          <CardNews v-for="(news, i) in unreadNews" :key="i" :item="news" @toggleMenuNews="toggleMenuNews"/>
        </div>
        <div class="news-menu-body" v-else>
          <span class="no-news">No hay noticias nuevas</span>
        </div>
        <div class="news-menu-controlls">
          <v-btn
            color="primary"
            class="news-menu-btn"
            @click="redirect"
          >
            Ver todas
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BellIcon from './BellIcon.vue';
  import CardNews from './CardNews.vue';
  import { mapState } from "vuex";

  export default {
    props:['isSubMenuActive'],
    components: { BellIcon, CardNews },
    computed: {
      ...mapState({
        news: (state) => state.news.items
      }),
      quantity() {
        return this.unreadNewsMethod().length > 9 ? '+9' : this.unreadNewsMethod().length
      },
      unreadNews(){
        return this.unreadNewsMethod()
      }
    },
    data: () =>({
      openNews: false
    }),
    methods: {
      unreadNewsMethod(){
        return this.news.filter(notice => {
          return !notice.viewedAt
        })
      },
      toggleMenuNews(){
        this.openNews = !this.openNews;
        if(this.openNews){
          document.documentElement.classList.add('modal-open');
        }
        if(!this.openNews && !this.isSubMenuActive){
          document.documentElement.classList.remove('modal-open');
        }
        if(this.isSubMenuActive){
          this.$emit('closeMenuProfile')
        }
      },
      redirect(){
        this.$router.push('/noticias');
        this.openNews = false;
        document.documentElement.classList.remove('modal-open');
      },
      closeMenu(){
        this.openNews = false;  
        if(!this.isSubMenuActive){
          document.documentElement.classList.remove('modal-open');
        }
      }
    },
    watch:{
      // bell animation on change length news
      news(){
        this.$refs.bellIcon.$el.classList.remove('animated')
        setTimeout(() => {
          this.$refs.bellIcon.$el.classList.add('animated')
        }, 200);
      }
    }
  }
</script>


<style scoped lang="scss">
  @import '@/scss/variables.scss';

  .overlay-news {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.134);
    width: 115dvw;
    height: 115dvh;
    right: calc(100% - 285px);
    top: calc(100% - 110px);
    z-index: 5;

    @media screen and (max-width: 1366px){
      right: calc(100% - 250px);
    }

    @media screen and (max-width: 767px){
      right: 0;
      top: 0;
    }
  }

  .NewsPanel {
    position: relative;

    .bell-icon {
      border-radius: 50%;
      border: 1px solid $c4;
      width: auto;
      padding: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: 0.3s;
      margin-bottom: 20px;
      position: relative;

      @media screen and (max-width: 768px){
        margin-bottom: 0;
      }

      &:hover {
        border: 1px solid $c3;
      }

      &.open {
        background-color: $c4;
        border: 1px solid $c4;
      }

      .quantity-news {
        position: absolute;
        right: -7px;
        top: -7px;
        background-color: red;
        border-radius: 50%;
        width: 23px;
        height: 23px;
        font-size: 14px;
        font-family: $lexend-font;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $cwhite;
        font-weight: 700;
        padding: 2px;
      }
    }

    .news-menu {
      position: absolute;
      background-color: $cwhite;
      width: 343px;
      right: 0;
      border-radius: 30px;
      font-family: $lexend-font;
      z-index: 5;
      box-shadow: 2px 3px 8px #000000b3;

      @media screen and (max-width: 767px) {
        width: calc(100dvw - 60px);
        right: -50px;
        display: flex;
        flex-direction: column;
        max-height: calc(100dvh - 80px);
        margin: 0 25px;
      }

      .news-menu-header {
        padding: 18px 23px 12px;
        border-bottom: 1px solid $c9;
      }

      .news-menu-body {
        max-height: 450px;
        padding: 0 26px 0 13px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        overflow-y: auto;

        @media screen and (max-width: 767px) {
          max-height: unset;
        }

        &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
          border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb {
          box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
          background-color: $c4;
          border-radius: 10px;
        }

        &::-webkit-scrollbar-track {
          background-color: $c9;
          border-radius: 10px;
        }

        .no-news {
          margin: 15px 0;
          text-align: center;
        }
      }

      .news-menu-controlls {
        margin-top: 15px;
        padding: 0 30px 15px;

        .news-menu-btn {
          width: 100%;
        }
      }
    }
  }
</style>

<style lang="scss">
  // styles to svg icon component
  @import '@/scss/variables.scss';

  .NewsPanel {
    .bell-icon {
      &.open {
        svg {
          g {
            path {
              fill: $cwhite;
            }
          }
        }
      }

      svg {
        &.animated {
          animation-name: bellAlert;
          animation-duration: 1.5s;
          animation-iteration-count: 3;
        }

        g {
          path {
            fill: $c4;
            transition: 0.3s;
          }
        }
      }
    }
  }
</style>